import { handleActions } from 'redux-actions'

import { signUpThunk } from './sign_up'
import { signInThunk } from './sessions'
import { prolong } from './sessions/prolong'
import { signOutThunk } from './sign_out'

export default handleActions(
  {
    [signUpThunk.SUCCEEDED]: (state, { payload }) => payload.headers.get('Authorization'),
    [signInThunk.SUCCEEDED]: (state, { payload }) => payload.headers.get('Authorization'),
    [prolong.SUCCEEDED]: (state, { payload }) => payload.headers.get('Authorization'),
    [signOutThunk.ENDED]: () => ''
  },
  ''
)



// WEBPACK FOOTER //
// ./src/modules/users/authorization.js